<ul [ngClass]="getClassNames()">
  <ng-content></ng-content>
</ul>
